// extracted by mini-css-extract-plugin
export default {"loading":"FullPageLoader_loading__AbjoB","spinner":"FullPageLoader_spinner__7ZI5j"};